export type RequiredEvidenceStatus = "Missing" | "Expired" | "Expiring" | "Ok";

export type RequiredEvidenceStatusFilter =
    | "MissingOnly"
    | "MissingAndExpired"
    | "ExpiringWithin7Days"
    | "ExpiringWithin30Days"
    | "ExpiringWithin90Days"
    | "All";

export type RequiredEvidence = {
    evidenceTypeId: number;
    evidenceTypeName: string;
    status: RequiredEvidenceStatus;
    currentEvidenceId?: number;
    currentEvidenceDownloadUrl?: string;
    currentEvidenceValidFromDate?: string;
    currentEvidenceValidToDate?: string;
    evidenceTypeCoveredUntil?: string;
    evidenceTypeExpiresInDays?: number;
    isComplete: boolean;
};

export type RequiredEvidenceForEmissionsSource = RequiredEvidence & {
    emissionsSourceId: number;
    emissionsSourceName: string;
    emissionsSourceUniqueReference: string;
    emissionsSourceLocation: string;
};

export type AddOrganizationRequiredEvidenceDto = {
    evidenceTypeId: number;
};

export const emissionsSourceRequiredEvidenceOrderByKeys = [
    "EmissionsSourceUniqueReference",
    "EmissionsSourceName",
    "EvidenceTypeName",
] as const;

export type EmissionsSourceRequiredEvidenceOrderBy =
    (typeof emissionsSourceRequiredEvidenceOrderByKeys)[number];

export const isEmissionsSourceRequiredEvidenceOrderBy = (
    value: string
): value is EmissionsSourceRequiredEvidenceOrderBy => {
    return emissionsSourceRequiredEvidenceOrderByKeys.includes(
        value as EmissionsSourceRequiredEvidenceOrderBy
    );
};
